import { ResolverTag } from '@ps/web-core-enums';
import { CrossPlatformLink, useResolver } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import CMSHTML from '../../../../../CMSHTML/CMSHTML';
import CMSImage from '../../../../../CMSImage/CMSImage';
import type { Props } from '../../TopHeader';

import styles from './RegulatoryHeaderCAON.scss';

const RegulatoryHeaderCAON: React.FC<Props> = ({
  regulatory_header: [
    {
      icons,
      texts: [{ content }]
    }
  ]
}) => {
  const iGamingOntario = useResolver(ResolverTag.IGamingOntario);
  const locale = useSelector(select.locale.get);

  return (
    <div className={styles.regulatoryHeader}>
      <div className={styles.regulatoryText}>
        <CMSHTML content={content} />
      </div>
      <CrossPlatformLink href={iGamingOntario} openLinkInNewTab>
        <CMSImage {...(locale === 'en' ? icons[0] : icons[1])} />
      </CrossPlatformLink>
    </div>
  );
};

export default RegulatoryHeaderCAON;
